import { types, Instance } from 'mobx-state-tree';
import { coBrandingDefaultValues } from '@constants/cobranding';

const CoBrandingConfig = types
  .model({
    contactInfo: types.optional(
      types.model({
        email: '',
        phone: '',
      }),
      {},
    ),
    theme: types.optional(
      types.model({
        primaryColor: coBrandingDefaultValues.primaryColor,
        secondaryColor: coBrandingDefaultValues.secondaryColor,
      }),
      {},
    ),
    assets: types.optional(
      types.model({
        favicon: '',
        logo: '',
      }),
      {},
    ),
  })
  .views((self) => ({
    get email() {
      return self.contactInfo.email;
    },

    get phone() {
      return self.contactInfo.phone;
    },

    get primaryColor() {
      return self.theme.primaryColor;
    },

    get secondaryColor() {
      return self.theme.secondaryColor;
    },

    get favicon() {
      return self.assets.favicon;
    },

    get logo() {
      return self.assets.logo;
    },
  }));

export default CoBrandingConfig;
export interface CoBrandingConfigStore extends Instance<typeof CoBrandingConfig> {}
